export default __webpack_public_path__ + "static/media/No-results-found.e1b49f03.gif";